const denomiations = {
  AUD: {
    5: 130,
    10: 137,
    20: 144,
    50: 151,
    100: 158
  },
  BBD: {
    2: 150,
    5: 150,
    10: 150,
    20: 150,
    50: 150,
    100: 150
  },
  CAD: {
    5: 152,
    10: 152,
    20: 152,
    50: 152,
    100: 152
  },
  CHF: {
    10: 126,
    20: 137,
    50: 148,
    100: 159,
    200: 170,
    1000: 181
  },
  DKK: {
    50: 125,
    100: 135,
    200: 145,
    500: 155,
    1000: 165
  },
  EUR: {
    5: 120,
    10: 127,
    20: 133,
    50: 140,
    100: 147,
    200: 153,
    500: 160
  },
  GBP: {
    5: 135,
    10: 142,
    20: 149,
    50: 156
  },
  HKD: {
    10: 134,
    20: 143,
    50: 148,
    100: 153,
    500: 158,
    1000: 163
  },
  HUF: {
    200: 154,
    500: 154,
    1000: 154,
    2000: 154,
    5000: 154,
    10000: 154,
    20000: 154
  },
  ILS: {
    20: 129,
    50: 136,
    100: 143,
    200: 150
  },
  JMD: {
    50: 145,
    100: 145,
    500: 145,
    1000: 145,
    5000: 145
  },
  JPY: {
    1000: 150,
    2000: 154,
    5000: 156,
    10000: 160
  },
  KZT: {
    200: 126,
    500: 130,
    1000: 134,
    2000: 139,
    5000: 144,
    10000: 155,
    20000: 155
  },
  MXN: {
    20: 120,
    50: 127,
    100: 134,
    200: 141,
    500: 148,
    1000: 155
  },
  MYR: {
    1: 120,
    5: 135,
    10: 140,
    20: 145,
    50: 145,
    100: 150
  },
  NZD: {
    5: 135,
    10: 140,
    20: 145,
    50: 150,
    100: 155
  },
  PHP: {
    20: 160,
    50: 160,
    100: 160,
    200: 160,
    500: 160,
    1000: 160
  },
  PLN: {
    10: 120,
    20: 126,
    50: 132,
    100: 138,
    200: 144,
    500: 150
  },
  SGD: {
    2: 126,
    5: 133,
    10: 141,
    50: 156,
    100: 162,
    1000: 170
  },
  TWD: {
    100: 145,
    200: 150,
    500: 155,
    1000: 160,
    2000: 165
  },
  UAH: {
    1: 118,
    2: 118,
    5: 118,
    10: 124,
    20: 130,
    50: 136,
    100: 142,
    200: 148,
    500: 154
  },
  USD: {
    1: 156,
    5: 156,
    10: 156,
    20: 156,
    50: 156,
    100: 156
  },
  VND: {
    10000: 132,
    20000: 136,
    50000: 140,
    100000: 144,
    200000: 148,
    500000: 152
  },
  ZAR: {
    10: 128,
    20: 134,
    50: 140,
    100: 146,
    200: 152
  }
}

export default denomiations
